import { Table, message } from "antd";
import React from "react";
import { RouteComponentProps } from "react-router";
import { NavLink } from "react-router-dom";
import Card from "../components/Card";
import { Entitlement } from "../helpers/shared-interfaces";
import { request } from "../helpers/utilities";
import { GET_ENTITLEMENTS } from "../gql/general";
import { PageToolbar } from "../components/PageToolbar";
import { PAGE_SIZE } from "../helpers/constants";
import { generateDisplayErrorMessage } from "../helpers/utilities";


interface State {
  isFiltering: boolean;
  entitlements: Entitlement[];
  filteredEntitlements: Entitlement[];
  filterBy: string;
  isLoading: boolean;
  showDialog: boolean;
  page: number,
  pageSize: number,
}

export const columns = [
  {
    title: "Entitlements",
    dataIndex: "name",
    key: "Entitlements",
    width: "65%",
    render(text: string, record: Entitlement): JSX.Element {
      return (
        <NavLink
          to={`/entitlements/${record.id}`}
          data-cy="test-exceptions-details-link"
        >
          {text}
        </NavLink>
      );
    },
  },
];

export function EntitlementTableFactory(data: Entitlement[], isLoading: boolean): JSX.Element {
  const tempData: Entitlement[] = data.map(
    (exception: Entitlement): Entitlement => {
      return { ...exception, key: exception.id };
    },
  );
  return (
    <Table
      loading={isLoading}
      scroll={{ x: 500 }}
      columns={columns}
      dataSource={tempData}
    />
  );
}

export default class Entitlements extends React.Component<
  RouteComponentProps,
  State
> {
  constructor(props: RouteComponentProps) {
    super(props);
    this.state = {
      showDialog: false,
      filterBy: "",
      isLoading: true,
      entitlements: [],
      filteredEntitlements: [],
      isFiltering: false,
      page: 1,
      pageSize: PAGE_SIZE,
    };

    this.getAllEntitlements = this.getAllEntitlements.bind(this);
    this.filterEntitlements = this.filterEntitlements.bind(this);
  }

  filterEntitlements(e: React.ChangeEvent<HTMLInputElement>): void {
    const filterBy = e.target.value;
    const isFiltering = !!filterBy;

    const filtered = this.state.entitlements.filter((entitlement) =>
      entitlement.name.toLowerCase().includes(filterBy.toLowerCase()),
    );

    this.setState({
      filterBy,
      isFiltering,
      filteredEntitlements: filtered,
    });
  }

  getAllEntitlements = async (): Promise<void> => {
    try {
      const { data: { data } }: any = await request({
        query: GET_ENTITLEMENTS,
      });
      this.setState({
        entitlements: data.entitlements,
      });
    } catch (error) {
      message.error(`Failed to load entitlements - ${generateDisplayErrorMessage(error)}`);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  async componentDidMount(): Promise<void> {
    this.setState({ isLoading: true });
    await this.getAllEntitlements();
  }

  filterOutViewEntitlements = (entitlements: Entitlement[]): Entitlement[] => {
    return entitlements.filter((e: Entitlement): boolean => !!e.relatedModel);
  };

  render(): JSX.Element | null {
    const { entitlements, isFiltering, filteredEntitlements, isLoading } =
      this.state;
    return (
        <Card>
          <div className="exceptionEntitlements-table-container">
            <PageToolbar modelName="entitlements"
              searchPlaceholder="Filter by..."
              onSearchChange={this.filterEntitlements}
              searchValue={this.state.filterBy}
              totalCount={entitlements.length}
              currentDataCount={
                isFiltering ? filteredEntitlements.length : entitlements.length
              }
              page={this.state.page}
              pageSize={this.state.pageSize}
            />
            {EntitlementTableFactory(isFiltering ? filteredEntitlements : entitlements, isLoading)}
          </div>
        </Card>
    );
  }
}
